<template>
  <div class="eno-header">
    <div class="header-logo">
      <img :src="config.logo" alt="">
    </div>
    <div class="header-menu" v-if="!isMobile">
      <enoMenu/>
    </div>
    <div class="header-right" v-else>
      <H5_MENU/>
      <div class="header-info">
        <enoInfo/>
      </div>
    </div>
    <!-- <div class="header-search">
      <enoSearch/>
    </div> -->
  </div>
</template>

<script>
import {menu} from '../../constant/menu.js'
import {style} from '../../constant/style.js'
import {config} from '../../constant/config.js'
import enoMenu from './component/menu.vue'
import enoSearch from './component/search.vue'
import enoInfo from './component/info.vue'
import H5_MENU from './component/h5_menu.vue'

export default {
  name: 'enoHeader',
  components: {enoMenu, enoSearch, enoInfo, H5_MENU},
  data() {
    return {
      menusList: menu,
      style: style,
      config: config
    }
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    }
  },
  mounted() {
    // window.addEventListener("scroll", this.changeHeadBg);
  },
  methods: {},

}
</script>

<style lang='less' scoped>
.eno-header {
  height: 74px;
  background-color: @mainBgColor;
  width: 100%;
  /* position: static; */
  /* top: 0; */
  padding: 0 32px;
  display: grid;
  grid-template-columns: 160px auto 80px 220px;
  position: sticky;
   z-index: 999;
  top: 0;

  .header-logo {
    display: flex;
    align-items: center;
    width: 100px;
  }

  .header-menu {
    display: flex;
    align-items: flex-end;
  }

  .header-search {

  }

  .header-info {

  }
}

@media @mobile {
  .eno-header {
    height: 75px;
    background-color: @mainBgColor;
    width: 100%;
    /* position: static; */
    /* top: 0; */
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-logo {
      /* display: flex;
       align-items: center;*/
    }

    .header-right {
      .header-menu {
        display: flex;
        align-items: center;
      }
    }

  }
}

</style>

